<template>
  <div class="bb-tax-credit-note-wrapper">
    <transition name="fade" appear>
      <LoaderFly v-if="loaderRun"/>
    </transition>
    <div class="bb-tax-credit-note">
      <div class="bb-tax-credit-note-header">
        <h1 class="bb-tax-credit-note-header-title">Tax credit note</h1>
        <div class="bb-tax-credit-note-header-wrapper">
          <div class="bb-tax-credit-note-header-wrapper__total">
            TOTAL AED {{numeralConvertNumber(this.totalCreditNotes)}}
          </div>
          <div class="bb-tax-credit-note-header-wrapper-container">
            <button class="bb-button
                           bb-tax-credit-note-header-wrapper-container__button"
                    @click="refundOpen = true"
            >
              Refunds
            </button>
            <div class="bb-tax-credit-note-header-wrapper-container-menu">
              <i class="icon-menu bb-tax-credit-note-header-wrapper-container-menu__icon"
                 @click.stop="popupNewHandover = !popupNewHandover"
                 :class="{
                  'bb-tax-credit-note-header-wrapper-container-menu__icon_disabled': selectedDocuments.length === 0
              }"/>
              <transition name="bounce">
                <div v-if="popupNewHandover"
                     @mouseleave="popupNewHandover = false"
                     class="bb-popup bb-tax-credit-note-header-wrapper-container-menu-popup"
                >
                  <p class="bb-popup__item bb-tax-credit-note-header-wrapper-container-menu-popup__text"
                     @click.stop="openRefundHandOver"
                  >
                    Include all in Refund
                  </p>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="bb-tax-credit-note__line"/>
      <CreditNoteTable v-if="taxCreditNoteList.length >= 1"
                       @addCreditNote="documentChecked"
                       @openTaxCreditNote="openTaxCreditNote"
                       :rows="taxCreditNoteList"/>
      <TableNoData :description="descriptionText" v-else/>
      <div class="bb-tax-credit-note-info"
           @click="showCompleted = !showCompleted"
           v-if="completedCreditNotes.length > 0"
      >
        +{{completedCreditNotes.length}} COMPLETED TAX CREDIT NOTES
      </div>
      <transition name="slide-select">
        <CreditNoteTable v-if="showCompleted && completedCreditNotes.length >= 1"
                         :completeStatus="true"
                         @openTaxCreditNote="openTaxCreditNote"
                         :rows="taxCreditNoteList"
        />
      </transition>
    </div>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="refundHandOver"
                   @close="handoverClose"
                   :without-padding="true"
      >
        <RefundHandoverForm @close="handoverClose"
                            @create="CreateRefund"
                            :selectedDocuments="selectedDocuments"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="creditNoteProforma" @close="closeCreditNoteProforma">
        <template v-slot:buttons>
          <div class="bb-tax-credit-note__send">
            <ButtonsEdit :left-if="true"
                         @edit="proformaEvents.create()"
                         @delete="proformaEvents.cancel()"
                         no-pop-up="false"
                         btn-right-text="CANCEL"
                         btn-left-text="DOWNLOAD"
                         styles="accent"/>
          </div>
        </template>
        <CreditNoteProforma ref="proformaCreditNote"
                            :editableSoaCreditNote="editableSoaCreditNote"
                            @close="closeCreditNoteProforma"
                            :view-mode="true"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="refundOpen"
                   @close="refundOpen = false"
      >
        <RefundHandoversList/>
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import SoaCreditNote from '@/api/SoaCreditNote/api'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import CreditNoteProforma from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteProforma'
import RefundHandoverForm
  from '@/components/Dissemination/Sales/CRM/ContactCard/RefundHandovers/RefundHandoverForm/RefundHandoverForm'
import convertNumber from '@/mixin/convertNumber'
import TableNoData from '@/components/Main/BBTable/TableNoData/TableNoData'
import RefundHandoversList
  from '@/components/Dissemination/Sales/CRM/ContactCard/RefundHandovers/RefundHandoversList/RefundHandoversList'
import CreditNoteTable
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteTable/CreditNoteTable'
import {get, findIndex} from 'lodash'
export default {
  name: 'TaxCreditNote',
  mixins: [convertNumber],
  components: {
    LoaderFly,
    CreditNoteTable,
    ModalWindow,
    ButtonsEdit,
    RefundHandoversList,
    CreditNoteProforma,
    RefundHandoverForm,
    TableNoData
  },
  data () {
    return {
      loaderRun: false,
      taxCreditNote: {},
      selectedDocuments: [],
      notCompletedCreditNotes: [],
      completedCreditNotes: [],
      popupNewHandover: false,
      creditNoteProforma: false,
      refundOpen: false,
      refundHandOver: false,
      editableSoaCreditNote: '',
      descriptionText: 'Sorry, but not found Credit notes',
      totalCreditNotes: 0,
      showCompleted: false,
      proformaEvents: {
        create: false,
        cancel: false
      }
    }
  },
  computed: {
    taxCreditNoteList: {
      get: function () {
        return this.$store.getters.taxCreditNotes
      },
      set: function (data) {
        this.$store.dispatch('setTaxCreditNotes', data)
      }
    }
  },
  methods: {
    async getCreditNotes () {
      try {
        const { data } = await SoaCreditNote.getSoaCreditNotes({client: this.$route.params.id})
        return data.soacreditnotes
      } catch (e) {
        console.error(e)
      }
    },
    documentChecked (item) {
      const index = findIndex(this.selectedDocuments, {_id: item._id})
      if (index === -1) {
        this.selectedDocuments.push(item)
      } else {
        this.selectedDocuments.splice(index, 1)
      }
    },
    openRefundHandOver () {
      this.refundHandOver = true
    },
    handoverClose () {
      this.refundHandOver = false
    },
    closeCreditNoteProforma () {
      this.editableSoaCreditNote = ''
      this.creditNoteProforma = false
    },
    openTaxCreditNote (creditNote) {
      const creditNoteId = get(creditNote, '_id', '')
      if (!creditNoteId) return
      this.loaderRun = true
      SoaCreditNote.getSoaCreditNotesById(creditNoteId)
        .then(({ data }) => {
          this.loaderRun = false
          this.editableSoaCreditNote = data
          this.creditNoteProforma = true
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    async getContactsTotal () {
      try {
        const { data } = await SoaCreditNote.getTotalCreditNote(this.$route.params.id)
        return data.total
      } catch (e) {
        console.error(e)
      }
    },
    async getTaxCreditNotes () {
      this.loaderRun = true
      const contactsTotal = await this.getContactsTotal()
      const soaCreditNoteList = await this.getCreditNotes()
      this.totalCreditNotes = contactsTotal
      this.taxCreditNoteList = soaCreditNoteList
      this.completedCreditNotes = soaCreditNoteList.filter(item => item.status === 3)
      this.loaderRun = false
    },
    CreateRefund () {
      this.selectedDocuments.splice(0, this.selectedDocuments.length)
      this.getTaxCreditNotes()
    }
  },
  updated () {
    if (this.$refs.proformaCreditNote) {
      this.proformaEvents.create = this.$refs.proformaCreditNote.downLoadCreditNoteProforma
      this.proformaEvents.cancel = this.$refs.proformaCreditNote.cancelProforma
    }
  },
  beforeMount () {
    this.getTaxCreditNotes()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-tax-credit-note-wrapper {
    margin: auto;
    max-width: 100%;
  }

  .bb-tax-credit-note {
    @include global-font;
    background: $color-white;
    border-radius: 5px;
    min-width: 700px;

    &-header {
      margin-bottom: 26px;

      &-title {
        font-size: 18px;
        font-weight: bold;
        line-height: 21px;
        color: $color-black;
      }

      &-wrapper {
        display: grid;
        grid-template-columns: minmax(156px, 1fr) 171px;
        padding-top: 27px;

        &__total {
          font-weight: 600;
          font-size: 14px;
          display: flex;
          padding: 10px 0;
          align-items: center;
          justify-content: center;
          line-height: 17px;
          border-radius: 5px;
          width: 156px;
          background-color: rgba($color-denim, 0.15);
          color: $color-denim;
        }

        &-container {
          display: inline-flex;
          align-items: center;
          justify-content: space-between;

          &__button {
            width: 133px;
            text-transform: uppercase;
          }

          &-menu {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-right: -10px;
            height: 42px;
            width: 42px;

            &__icon {
              transform: rotate(90deg);
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 20px;
              color: $color-accent;
              cursor: pointer;
              width: 100%;
              height: 100%;

              &_disabled {
                pointer-events: none;
                color: $color-dusty-gray;
              }

              &:hover {
                color: $color-accent-hover;
              }
            }

            &-popup {
              box-shadow: 0 0 20px rgba($color-black, 0.08);
              padding: 6px 10px 0;
              width: auto;
              left: auto;
              right: 7px;
              white-space: nowrap;
              font-weight: 300;
              font-size: 13px;
              line-height: 16px;

              &__text {
                padding: 6px;
                margin-bottom: 6px;
                cursor: pointer;
                transition: 0.3s;

                &:hover {
                  opacity: 0.7;
                }

                &:first-child {
                  margin-top: 0;
                }
              }
            }
          }
        }
      }
    }

    &__send {
      position: relative;
      padding-bottom: 0;
      padding-top: 30px;
      margin-right: 8px;
      display: flex;
      justify-content: flex-end;
      box-shadow: 0 -10px 35px -15px rgba($color-silver, 0.4);
    }

    &__line {
      height: 1px;
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      background-color: $color-mercury;
    }

    &-info {
      display: flex;
      width: 247px;
      align-items: center;
      margin: 27px auto 10px 0;
      padding: 10px 15px;
      border: 1.5px solid $color-accent;
      box-sizing: border-box;
      border-radius: 5px;
      font-weight: 600;
      font-size: 13px;
      color: $color-accent;
      cursor: pointer;
      white-space: nowrap;

      &:hover {
        color: $color-accent-hover;
        border-color: $color-accent-hover;
      }

      &__wrapper-popup {
        position: relative;
      }

      &__totals {
        color: $color-silver-chalice;
        margin-left: 13px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TaxCreditNote.vue